import { render, staticRenderFns } from "./DefaultHeaderDropdownTasks.vue?vue&type=template&id=70b675e0&"
import script from "./DefaultHeaderDropdownTasks.vue?vue&type=script&lang=js&"
export * from "./DefaultHeaderDropdownTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports